import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme, type ThemeChoice } from "../context/ThemeContext.js";

const OPTIONS: { value: ThemeChoice; label: string; icon: typeof Sun }[] = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Monitor },
];

// A 3-way segmented control rather than a single on/off switch, so "follow
// the OS" stays a first-class, reachable choice rather than something only
// achievable by never touching the toggle. The selection is drawn by one
// thumb that slides between the three equal columns (see .sidenav-seg in
// tokens.css); the buttons themselves carry no background.
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const index = Math.max(0, OPTIONS.findIndex(o => o.value === theme));

  return (
    <div role="radiogroup" aria-label="Theme" className="sidenav-seg" data-index={index}>
      <span className="sidenav-seg__thumb" aria-hidden="true" />
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={theme === value}
          aria-label={label}
          title={label}
          onClick={() => setTheme(value)}
          className="sidenav-seg__btn"
        >
          <Icon size={14} strokeWidth={1.8} />
        </button>
      ))}
    </div>
  );
}
